import { Button } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import React, { memo, useEffect, useState } from 'react';
import {
    buildFreeMessage,
    buildListCategoriesMessage,
    buildQAFormLiveChat,
    buildQAFormMessage,
    checkMessageOutOfSession,
	postMessage
} from '../handler/ChatBoxHandler';
import { useRecoilValue } from 'recoil';
import { updatePreviewSettingAtom } from '@/state/atom/chatBotPreview';
import Constant from "@/common/constant/Constant";
import { v4 as uuidv4} from 'uuid';

function BackToBeginMessage({
    message,
    setMessages,
    listCategories,
    supportThreadIdState,
    affiliationOrganization,
    messages,
    chatbotSetting,
    isModePreview,
    isMaximizedPanel,
    formQASystem,
    setIsEnableMsgInput
}) {
    const [messageState, setMessagesState] = useState(message)
    useEffect(() =>{
        if (message.idMessage !== messageState.idMessage) {
            setMessagesState(message)
        }
    }, [message])
    const previewSetting = useRecoilValue(updatePreviewSettingAtom);
    const [freeMessage, setFreeMessage] = useState('');

    useEffect(() => {
        if (!isModePreview) {
            setFreeMessage(chatbotSetting.freeMsg);
        }
    }, [chatbotSetting]);

    useEffect(() => {
        if (isModePreview) {
            if (previewSetting.freeMsg !== freeMessage) {
                setFreeMessage(previewSetting.freeMsg);
            }
        }
    }, [previewSetting]);

    const onClickNextSessionHandler = () => {
        if (checkMessageOutOfSession(messages, message.idMessage)) return;
        let setting = isModePreview ? previewSetting : chatbotSetting;
        let nextMessage;
        let uuidOfMessage = `qaform_${uuidv4()}`;

        if (listCategories.length === 0) {
            switch(setting?.actionWhenNotResolve) {
                case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.CREATE_TICKET_AND_CHAT_WITH_AGENT:
                    let dataLiveChat = {
                        isDefault: true,
                        formQASystem: formQASystem,
                        idQA: uuidOfMessage
                    }
                    nextMessage = buildQAFormLiveChat(dataLiveChat);
                    break;
    
                case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.CREATE_TICKET_AND_FINISH:
                   
                    let data = {
                        isDefault: true,
                        data: {
                            formQASystem: formQASystem
                        },
                        idQA: uuidOfMessage
                    }
                    nextMessage = buildQAFormMessage(data, 'CBOTMSG011');
                    break;
                case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.DISPLAY_FREE_MESSAGE:
                default:
                    nextMessage = buildFreeMessage(freeMessage, 0);
                    break;
            }
        } else {
            nextMessage = buildListCategoriesMessage(listCategories);
        }

        postMessage(
            nextMessage,
            supportThreadIdState,
            affiliationOrganization,
            false,
            isModePreview,
            uuidOfMessage
        );
        setMessages(pev => [...pev, nextMessage]);
        setIsEnableMsgInput(true)
    };
    return (
        <div className={isMaximizedPanel ? 'message-text maximized-form-text' : 'message-text'}>
            <div>{message.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.BACK_TO_BEGIN_AFTER_REJECT ? message.content :message.content[0]}</div>
            <Button className={`back-to-begin-btn ${isMaximizedPanel ? 'maximized-form': 'minimized-form'}`} onClick={onClickNextSessionHandler}>
                {I18n.get('CBOTBT004')}
            </Button>
        </div>
    );
}

export default memo(BackToBeginMessage)
